import apiEndPoints from '../utils/ctxUtil';
import { adalApiFetch } from '../adalConfig';
import { toast } from 'react-toastify';

export function redirectToDealFunderListPage(bool) {
  return {
    type: 'REDIRECT_TO_DEAL_FUNDER_LIST',
    redirect: bool,
  };
}

export function redirectToDealFunder(id) {
  return {
    type: 'REDIRECT_TO_DEAL_FUNDER',
    id: id,
  };
}

export function dealFunderFetchDataResult(funderDetails) {
  return {
    type: 'DEAL_FUNDER_DETAILS_FETCH_DATA_RESULT',
    funderDetails,
  };
}

export function dealFunderClearDetails() {
  return {
    type: 'DEAL_FUNDER_CLEAR_DETAILS',
    funderDetails: {},
  };
}

export function dealFunderDetailsLoading(bool) {
  return {
    type: 'DEAL_FUNDER_DETAILS_LOADING',
    isLoading: bool,
  };
}

export function dealFunderDetailsSaving(bool) {
  return {
    type: 'DEAL_FUNDER_DETAILS_SAVING',
    isSaving: bool,
  };
}

export function getDealFunder(id) {
  // if (!id) {
  //   return (dispatch) => {
  //     console.log('getDealFunder called without an ID');
  //     dispatch(dealFunderDetailsLoading(false));
  //     dispatch(dealFunderClearDetails());
  //   };
  // }
  const url = apiEndPoints.FUNDER.replace('{dealFunderId}', id);

  return (dispatch) => {
    dispatch(dealFunderDetailsLoading(true));
    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(dealFunderDetailsLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((item) => {
        dispatch(dealFunderFetchDataResult(item));
      })
      .catch(() => {
        dispatch(dealFunderDetailsLoading(false));
      });
  };
}

export function saveDealFunder(isNew, data, originalState) {
  const id = data.id;
  const url = apiEndPoints.FUNDER.replace('{dealFunderId}', isNew ? '' : id);

  return (dispatch) => {
    dispatch(dealFunderDetailsSaving(true));
    adalApiFetch(fetch, url, {
      method: isNew ? 'POST' : 'PUT',
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        dispatch(dealFunderDetailsSaving(false));

        switch (response.status) {
          case 202: {
            dispatch(dealFunderFetchDataResult(originalState));
            dispatch(() => toast.success('Data saved successfully'));
            if (isNew) {
              dispatch(redirectToDealFunder(id));
            }

            break;
          }
          case 422: {
            dispatch(
              dealFunderFetchDataResult({
                ...originalState,
                isNew: isNew,
              }),
            );

            response.json().then((error) => {
              // work-around for IE 11
              const ObjectValues = function values(object) {
                return Object.keys(object).map((key) => object[key]);
              };

              // IE 11 does not support Object.Values
              const items = Object.values
                ? Object.values(error)
                : ObjectValues(error);
              const message = items.join('; ');
              dispatch(() => toast.error(message));
            });
            break;
          }
          default:
            throw response;
        }
      })
      .catch((error) =>
        error
          .json()
          .then((response) => dispatch(() => toast.error(response.message))),
      );
  };
}
